import { ISearchRequest } from './i-searchrequest.interface';

export class SearchRequest implements ISearchRequest {
    page: number;
    searchText : string;
    facets : string[];
    sort: string;
    active: boolean;
    showAllData?: boolean;

    constructor() {
        this.facets = [];
        this.page = 1;
    }
}